module.exports = __webpack_public_path__ + "img/softinya-10.a012108d.png";